import { render, staticRenderFns } from "./ReceiveMessagesSystem.vue?vue&type=template&id=a4b9d228&scoped=true"
import script from "./ReceiveMessagesSystem.vue?vue&type=script&lang=js"
export * from "./ReceiveMessagesSystem.vue?vue&type=script&lang=js"
import style0 from "./ReceiveMessagesSystem.vue?vue&type=style&index=0&id=a4b9d228&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b9d228",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4b9d228')) {
      api.createRecord('a4b9d228', component.options)
    } else {
      api.reload('a4b9d228', component.options)
    }
    module.hot.accept("./ReceiveMessagesSystem.vue?vue&type=template&id=a4b9d228&scoped=true", function () {
      api.rerender('a4b9d228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/other/ReceiveMessagesSystem.vue"
export default component.exports